import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, Home, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import AdminSidebar from "./AdminSidebar";
import { useAuth } from "@/contexts/AuthContext";

const AdminHeader = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();
  const { signOut } = useAuth();
  
  const handleSignOut = async () => {
    try {
      setMobileNavOpen(false);
      await signOut();
    } catch (error) {
      console.error("Error during logout:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to log out"
      });
      navigate("/verify");
    }
  };
  
  const toggleMobileNav = () => {
    setMobileNavOpen(!mobileNavOpen);
  };
  
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-2 md:gap-4">
          <button 
            className="block md:hidden rounded-md p-2 text-gray-500 hover:bg-gray-100" 
            onClick={toggleMobileNav} 
            aria-label={mobileNavOpen ? "Close navigation menu" : "Open navigation menu"}
          >
            {mobileNavOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
          
          <h1 className="text-xl font-bold">Admin Dashboard</h1>
        </div>
        
        <div className="flex items-center gap-4">
          <Link to="/account/subscription">
            <Button variant="outline" size="sm" className="hidden sm:flex">
              Subscription
            </Button>
          </Link>
          <Link to="/" target="_blank">
            <Button variant="outline" size="sm" className="hidden sm:flex">
              <Home className="h-4 w-4 mr-2" />
              View Site
            </Button>
          </Link>
          
          <Button variant="ghost" size="sm" onClick={handleSignOut}>Log Out</Button>
        </div>
      </div>
      
      {mobileNavOpen && (
        <div className="md:hidden fixed inset-0 bg-white z-40 pt-16">
          <div className="absolute top-4 right-4">
            <Button 
              variant="ghost" 
              size="icon"
              onClick={() => setMobileNavOpen(false)}
              className="p-2"
            >
              <X size={20} />
            </Button>
          </div>
          <div className="p-4 overflow-y-auto h-full">
            <div className="mb-4">
              <Link to="/account/subscription" onClick={() => setMobileNavOpen(false)}>
                <Button variant="outline" className="w-full justify-start">
                  Subscription
                </Button>
              </Link>
            </div>
            <AdminSidebar onItemClick={() => setMobileNavOpen(false)} />
          </div>
        </div>
      )}
    </header>
  );
};

export default AdminHeader;
